export const SUPPORTED_THEMES = {
  main: "main",
};